import loggerManager from './log/logger-manager';

// user system clock may be inaccurate, so we need to adjust the timestamp
// based on the baseTime received from remote server

let baseTimeOffset = 0;
let isFirstTime = true;

export const setNetworkTimeOffset = function (offset: number) {
  baseTimeOffset = offset;
  const base = new Date();
  base.setTime(base.getTime() + offset);
  loggerManager[isFirstTime ? 'info' : 'debug'](`baseTime from server: ${base} offset: ${offset}`);
  isFirstTime = false;
};

export const getNetworkTimeOffset = function () {
  return baseTimeOffset;
};

export const getNetworkTime = function () {
  return Date.now() + baseTimeOffset;
};

export const getTimestamp = function () {
  const now = new Date();
  now.setTime(getNetworkTime());
  return now.toLocaleString();
};

export const formatDate = function (date: Date) {
  let milliseconds = String(date.getMilliseconds());
  if ('padStart' in String.prototype) {
    milliseconds = milliseconds.toString().padStart(3, '0');
  }
  return `${date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1')}:${milliseconds}`;
};
